import React from 'react';

import { Root } from './style';

function Block({ children }) {
  return <Root>{children}</Root>;
}

export default Block;
